import { useCallback } from "react";
import { useEffect } from "react";

import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import LoadingPage from "../components/LoadingPage/LoadingPage";
import VerifyEmailConfirmation from "../components/VerifyEmailConfirmation/VerifyEmailConfirmation";
import { UMSrequestClient } from "../stores/requestClient";

const VerifyEmailContainer = () => {
  const { hash } = useParams<{ hash: string }>();

  const submit = useCallback(
    () =>
      UMSrequestClient.publicRequest({
        method: "POST",
        url: "/edu/verify",
        body: { hash },
      }),
    [hash]
  );

  const { isIdle, isPending, isSuccess, mutate } = useMutation({ mutationFn: submit });
  useEffect(() => {
    mutate();
  }, [mutate]);

  if (isIdle || isPending) {
    return <LoadingPage />;
  }
  return <VerifyEmailConfirmation success={isSuccess} edu={true} />;
};

export default VerifyEmailContainer;
